import { render, staticRenderFns } from "./MetricTabs.vue?vue&type=template&id=3d801fcf&scoped=true"
import script from "./MetricTabs.vue?vue&type=script&lang=ts"
export * from "./MetricTabs.vue?vue&type=script&lang=ts"
import style0 from "./MetricTabs.vue?vue&type=style&index=0&id=3d801fcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d801fcf",
  null
  
)

export default component.exports